module.exports = __webpack_public_path__ + "img/logo-astra-motor-png-8.078b48a7.png";